/** 選定支援事例一覧のデータを保存している localState の key */
export const locationStateKey = 'caseListPageState';
